module.exports = "import React from 'react';\nimport DayPicker from 'react-day-picker';\nimport 'react-day-picker/lib/style.css';\n\nconst birthdayStyle = `.DayPicker-Day--highlighted {\n  background-color: orange;\n  color: white;\n}`;\n\nconst modifiers = {\n  highlighted: new Date(2018, 8, 19),\n};\n\nexport default function MyBirthday() {\n  return (\n    <div>\n      <style>{birthdayStyle}</style>\n      <DayPicker modifiers={modifiers} month={new Date(2018, 8)} />\n    </div>\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/modifiers-01.js
// module id = 802
// module chunks = 168707334958949